/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {
  JobBillingDto,
  JobRestService,
} from '@gh/builder-shared-data';

import { InitViewService, getRouteParam } from '@gh/common-shared';
import { JobBilling } from './cm.model';
import { Observable } from 'rxjs';
import { ID } from '@gh/common-shared-data';

@Injectable()
export class CmJobDetailsBusinessService implements InitViewService {

  constructor(private jobRest: JobRestService) {
  }

  initView(route: ActivatedRouteSnapshot): any {
    const jobId = getRouteParam(route, 'jobId');
    const officeId = getRouteParam(route, 'officeId');

    return {
      billing: this.get(officeId, jobId),
    };
  }

  get(officeId: ID, jobId: ID): Observable<JobBillingDto | JobBilling> {
    return this.jobRest.getBilling(officeId, jobId);
  }

  update(jobId: ID, jobBilling: JobBillingDto): Observable<JobBillingDto | JobBilling> {
    return this.jobRest.updateBilling(jobId, jobBilling);
  }

}
